import { render, staticRenderFns } from "./delivery-notice-details.vue?vue&type=template&id=44d103a6&scoped=true"
import script from "./delivery-notice-details.ts?vue&type=script&lang=ts&external"
export * from "./delivery-notice-details.ts?vue&type=script&lang=ts&external"
import style0 from "./delivery-notice-details.scoped.scss?vue&type=style&index=0&id=44d103a6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d103a6",
  null
  
)

export default component.exports